export default "__VITE_PUBLIC_ASSET__03679c03__"